const CIGSIDA_API_URL = 'https://cigsida.com/api/api.php';

const queryCigsida = async (table, columns, filters = [], order = []) => {
  const response = await fetch(CIGSIDA_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: 'query',
      table,
      method: 'select',
      columns,
      filters,
      order,
      limit: null,
      data: null,
      single: false,
    }),
  });

  const result = await response.json();
  if (!response.ok || result.error) {
    throw new Error(result.error || `CIGSIDA API request failed (${response.status})`);
  }

  if (!Array.isArray(result.data)) {
    throw new Error('CIGSIDA API returned an invalid response');
  }

  return result.data;
};

const normalizeImageUrl = (url) => {
  if (typeof url !== 'string' || !url) return '';

  return url.replace(
    /^https:\/\/[^/]+\/storage\/v1\/object\/public\//,
    'https://cigsida.com/api/storage/'
  );
};

export const getCigsidaCommitteeMembers = async () => {
  const editions = await queryCigsida('editions', 'id, is_active');
  const activeEdition = editions.find((edition) => (
    edition.is_active === true || edition.is_active === 1 || edition.is_active === '1'
  ));

  if (!activeEdition) {
    throw new Error('No active CIGSIDA edition was found');
  }

  const members = await queryCigsida(
    'apropos_committee_members',
    'id, name, title, organization, image_url, company_logo_url, display_order, is_honorary, is_organizing, is_president, is_scientific, is_expert',
    [['eq', 'edition_id', activeEdition.id]],
    [{ col: 'display_order', asc: true }]
  );

  return members.map((member) => ({
    ...member,
    image_url: normalizeImageUrl(member.image_url),
    company_logo_url: normalizeImageUrl(member.company_logo_url),
  }));
};

export const getCigsidaInternationalExperts = async () => {
  const members = await getCigsidaCommitteeMembers();

  return members.filter((member) => (
    member.is_expert === true || member.is_expert === 1 || member.is_expert === '1'
  ));
};
